export default identifier => `
  {
    quiz(identifier: "${identifier}") {
      name
      answeredQuestionsMinimum
      maximumResults
      loadingTeaserText
      resultsTitle
      resultsDescription

      start {
        copy
        ctaCopy
        byline
        backgroundColor
        backgroundImageSrc
        startQuestionId
      }

      shoes {
        id
        name
        rating
        summary
        price

        variants {
          id
          colorName
          productUrl
          imageUrl
          colorCodePrimary
          colorCodeSecondary
          skus
          filterValues
          spreeProduct
        }
      }

      questions {
        id
        copy

        answers {
          copy
          moreInfo
          nextQuestion
          ratingIncrease
        }
      }
    }
  }
`
